/* import __COLOCATED_TEMPLATE__ from './pix-gauge.hbs.js'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { warn } from '@ember/debug';
import Component from '@glimmer/component';
export default class PixGauge extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isLevelActive", index => {
      if (this.reachedLevel === 0 && index === 0) return true;
      const step = 8 / this.args.stepLabels.length;
      return index * step < this.reachedLevel && this.reachedLevel <= (index + 1) * step;
    });
    _defineProperty(this, "stepLabelX", index => {
      const stepStart = 1 / this.args.stepLabels.length;
      return `${stepStart * index + 1 / 2 * stepStart}`;
    });
    _defineProperty(this, "stepLineX", index => {
      const stepStart = 1 / this.args.stepLabels.length;
      return `${stepStart * index}`;
    });
    _defineProperty(this, "formatNumber", str => {
      const num = Number(str);
      const oneDigitNum = num.toFixed(1);
      if (oneDigitNum.toString().endsWith('0')) {
        return Math.ceil(oneDigitNum);
      }
      return oneDigitNum;
    });
  }
  get label() {
    warn('PixGauge: @label must be defined', !this.args.label, {
      id: 'pix-ui.gauge.label.not-defined'
    });
    return this.args.label;
  }
  get reachedLevel() {
    warn('PixGauge: @reachedLevel must be between 0 and 8', this.args.reachedLevel <= 8 || this.args.reachedLevel >= 0, {
      id: 'pix-ui.gauge.reachedLevel.not-defined'
    });
    return this.args.reachedLevel;
  }
  get maxLevel() {
    warn('PixGauge: @maxLevel must be between 1 and 8', this.args.maxLevel <= 8 || this.args.maxLevel >= 1, {
      id: 'pix-ui.gauge.maxLevel.not-defined'
    });
    return this.args.maxLevel;
  }
  get hideValues() {
    return this.args.hideValues ?? false;
  }
  get maxLevelPourcentage() {
    return this.maxLevel / 8;
  }
  get viewBox() {
    if (this.args.isSmall) {
      return '0 22 200 32';
    }
    return '0 0 100% 70';
  }
  get reachedLevelPercentage() {
    return this.reachedLevel / 8;
  }
  get whiteAndPurpleGaugeRx() {
    return this.args.isSmall ? 12 : 20;
  }
  get whiteAndPurpleGaugesHeight() {
    return this.args.isSmall ? 24 : 40;
  }

  // background
  get greyGaugeRx() {
    return this.args.isSmall ? 16 : 24;
  }
  get backgroundHeight() {
    return this.args.isSmall ? 32 : 48;
  }
  get statsFontHeight() {
    return this.args.isSmall ? 18 : 26;
  }
}